// @flow

import React from 'react';
import BoardCount from 'app/common/react/components/common/Count/BoardCount';
import FollowerCount from 'app/common/react/components/common/Count/FollowerCount';
import PinCount from 'app/common/react/components/common/Count/PinCount';
import TriedCount from 'app/common/react/components/common/Count/TriedCount';
import VideoPinCount from 'app/common/react/components/common/Count/VideoPinCount';
import VideoViews from 'app/common/react/components/common/Count/VideoViews';
import type { PinFeedFilterOptionsType, ProfileUser } from 'app/packages/pinterest-flow-types/user';
import {
  ProfileTabs,
  type ProfileTabType,
} from 'app/common/react/components/profile/ProfileHeader/ProfileTabBar';
import { Box, Text } from 'gestalt';

type Props = {
  alignCenter?: boolean,
  pinFeedFilter?: PinFeedFilterOptionsType,
  tab: ProfileTabType,
  user: ProfileUser,
};

export default function ProfileStatsBar({ alignCenter, pinFeedFilter, tab, user }: Props) {
  const {
    board_count: boardCount,
    follower_count: followerCount,
    pin_count: pinCount,
    pins_done_count: triedCount,
    scheduled_pin_count: scheduledPinCount,
    story_pin_count: storyPinCount,
    video_pin_count: videoPinCount,
    video_views: videoViews,
  } = user;

  if (
    tab !== ProfileTabs.BOARDS &&
    tab !== ProfileTabs.PINS &&
    tab !== ProfileTabs.FOLLOWERS &&
    tab !== ProfileTabs.TRIED &&
    tab !== ProfileTabs.VIDEO_PINS
  ) {
    return null;
  }

  // hide here and move pin count down with published pin section
  if (tab === ProfileTabs.PINS && !!scheduledPinCount) {
    return null;
  }

  let pinCountComponent = <PinCount count={pinCount} />;
  if (pinFeedFilter === 'STORY') {
    pinCountComponent = <PinCount count={storyPinCount} />;
  } else if (pinFeedFilter === 'VIDEO') {
    pinCountComponent = <VideoPinCount count={videoPinCount} />;
  } else if (pinFeedFilter === 'TRIES') {
    pinCountComponent = <TriedCount count={triedCount} />;
  }

  const boxProps = alignCenter
    ? { display: 'flex', justifyContent: 'center' }
    : { display: 'flex', marginBottom: 3, marginLeft: 1, paddingX: 3 };
  return (
    <Box justifyContent="center" display="flex">
      <Box {...boxProps} maxWidth={850} width="100%">
        <Text color="gray" size="sm">
          {tab === ProfileTabs.BOARDS && <BoardCount count={boardCount} />}
          {tab === ProfileTabs.PINS && pinCountComponent}
          {tab === ProfileTabs.FOLLOWERS && <FollowerCount count={followerCount} />}
          {tab === ProfileTabs.TRIED && triedCount > 0 && <TriedCount count={triedCount} />}
          {tab === ProfileTabs.VIDEO_PINS && (
            <Box display="flex">
              {videoPinCount > 0 && <VideoPinCount count={videoPinCount} />}
              {videoPinCount > 0 && !!videoViews && videoViews > 0 ? (
                <React.Fragment>
                  <Box paddingX={3}>•</Box>
                  <VideoViews views={videoViews} />
                </React.Fragment>
              ) : null}
            </Box>
          )}
        </Text>
      </Box>
    </Box>
  );
}
